<div class="container bg-light">
    <section class="common-section row">
        <div class="col-12 col-md-6">
            <app-world-clock></app-world-clock>
        </div>
        <div class="col-12 col-md-6">
            <app-date-difference></app-date-difference>
        </div>
    </section>
    
    <section class="common-section bg-light">
        <app-public-resources></app-public-resources>
    </section>

    <section class="common-section row">
        <app-contribution></app-contribution>
    </section>
</div>